import React, { useMemo } from "react";
import { Select, Skeleton } from "@mantine/core";
import { Bar } from "react-chartjs-2";
import { loadingStates } from "../../utilities/utilities";

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const YEAR_OPTIONS = Array.from({ length: 8 }, (_, i) => String(2022 + i));

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      title: {
        display: true,
        text: "Agreements",
      },
      grid: {
        display: false,
      },
      ticks: {
        precision: 0,
      },
    },
    x: {
      title: {
        display: true,
        text: "Month",
      },
      grid: {
        display: false,
      },
    },
  },
};

function AgreementGraph({ configs, year, setYear }) {
  const isLoading = configs.loading === loadingStates.LOADING;

  const monthlyData = useMemo(() => {
    const agreementByMonth = configs?.data?.agreementByMonth || [];
    return MONTHS.map((month) => {
      const monthData = agreementByMonth.find((el) => el.month === month);
      return monthData ? monthData._count.id : 0;
    });
  }, [configs?.data?.agreementByMonth]);

  const showChart =
    !isLoading && Array.isArray(configs?.data?.agreementByMonth);

  return (
    <div className="w-full">
      <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
          <h3 className="text-sm font-semibold capitalize text-gray-700">
            Monthly stats
          </h3>
          <Select
            value={String(year)}
            className="w-28"
            data={YEAR_OPTIONS}
            onChange={(val) => setYear(parseInt(val, 10))}
          />
        </div>

        {isLoading ? (
          <Skeleton height={220} radius="md" />
        ) : showChart ? (
          <div className="h-56 w-full">
            <Bar
              data={{
                labels: MONTHS,
                datasets: [
                  {
                    label: "Agreements",
                    backgroundColor: "rgb(70, 189, 225)",
                    barThickness: 28,
                    borderRadius: 6,
                    data: monthlyData,
                  },
                ],
              }}
              options={chartOptions}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default AgreementGraph;
